import { reactive } from 'vue'


// EXPORT
export const state = reactive({
    ecResults: [],
    eventID: '',
    widgetID: '',

    getEcResults() {
        return this.ecResults;
    },

    setEcResults(results) {
        this.ecResults = results;
    },

    getEventID() {
        return this.eventID;
    },

    setEventID(eventID) {
        this.eventID = eventID;
    },

    getWidgetID() {
        return this.widgetID;
    },

    setWidgetID(widgetID) {
        this.widgetID = widgetID;
    }

});